module.exports = __webpack_public_path__ + "img/02.18a8aea6.png";